import { api } from "./client";
import { toast } from "react-toastify";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Create a new store
export const createStore = async (storeData) => {
  try {
    const response = await api.post(`${API_BASE_URL}api/store/stores`, storeData, {
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": "en", // or dynamically switch
      },
    });
    return response.data;
  } catch (error) {
    console.error("Create Store Error:", error);
    toast.error(error?.response?.data?.error || `❌ ${window.translate("Failed to create store")}`);
    throw error;
  }
};

//get store api
export const getStores = async () => {
  const lang = localStorage.getItem("lang") || "en";
  try {
    const response = await api.get(`${API_BASE_URL}api/store/stores`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token")}`,
        "Accept-Language": lang
      },
    });
    return response.data;
  } catch (error) {
    console.error("Get Stores API Error:", error);
    throw error;
  }
};

// Update api
export const updateStore = async (id, updateData) => {
  try {
    const response = await api.put(
      `${API_BASE_URL}api/store/stores/${id}`,
      updateData,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("token")}`,
          "Accept-Language": localStorage.getItem("lang") || "en",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Update Store Error:", error);
    toast.error(
      error?.response?.data?.error || `❌ ${window.translate("Failed to update store")}`
    );
    throw error;
  }
};

// Delete a store
export const deleteStore = async (id) => {
  try {
    const response = await api.delete(`${API_BASE_URL}api/store/stores/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("token")}`,
        "Accept-Language": localStorage.getItem("lang") || "en",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Delete Store Error:", error);
    throw error;
  }
};

// get All store 
export const getAllStores = async () => {
  try {
    const response = await api.get(`${API_BASE_URL}api/store/stores`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Accept-Language": localStorage.getItem("lang") || "en",
      },
    });

    // return response.data; // return the data only
    return response.data.filter((s) => s.status === "Active");
  } catch (error) {
    console.error("❌ Error fetching stores:", error);
    throw error; // rethrow for useEffect to catch
  }
};